// Company add user - setup intl-tel-input on dynamic forms
document.addEventListener('DOMContentLoaded', () => {
  const usersContainer = document.querySelector('.users')
  if (!usersContainer) return

  const addButton = usersContainer.querySelector('.button.has_many_add')
  if (addButton) {
    addButton.addEventListener('click', () => {
      if (window.onFirstChildChange && window.setupIntlTelInput) {
        window.onFirstChildChange('.users', window.setupIntlTelInput)
      }
    })
  }
})

